import { Environment } from "@husbanken/frontend-starter";

export const environment: Environment = {
  appConfigUri: "/konfig/app.config.json",
  keycloakConfigUri: "/konfig/keycloak.json",
};
